export const environment = {
  production: false,
  name: 'dev',
  configFile: '/config/config.dev.json',
  // Uncomment to use the local backend EBR API during development
  // ebrApiUrl: 'https://localhost:44360',
  // Uncomment the line below to use the configuration values for the label 'localhost' in Azure App Configuration.
  // configurationKeyLabel: 'localhost',
};
